import {Injectable} from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpParams,
  HttpParameterCodec,
} from '@angular/common/http'

import {Observable} from 'rxjs'

class WebHttpUrlEncodingCodec implements HttpParameterCodec {
  encodeKey(k: string): string {
    return encodeURIComponent(k)
  }
  encodeValue(v: string): string {
    return encodeURIComponent(v)
  }
  decodeKey(k: string): string {
    return decodeURIComponent(k)
  }
  decodeValue(v: string) {
    return decodeURIComponent(v)
  }
}

@Injectable()
export class HttpParamsInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // escape all + in url parameters
    // TODO do proper escape
    let params: HttpParams = new HttpParams({
      encoder: new WebHttpUrlEncodingCodec(),
    })
    for (const key of req.params.keys()) {
      for (const param of req.params.getAll(key)) {
        params = params.append(key, param)
      }
    }

    return next.handle(req.clone({params: params}))
  }
}
